import React from "react";

import { useScoped } from "~/tools/impulse";

import { queryMetricsLabelValues } from "../../../../queries/metrics/labels";
import { useQuery } from "../../../../queries/react-query";
import { useDashboardContext } from "../_dashboard-context";

import { ListMultiChoiceVariable, type ListMultiChoiceVariableProps } from "./_list-multi-choice";
import { ListSingleChoiceVariable, type ListSingleChoiceVariableProps } from "./_list-single-choice";

type MultiChoiceProps = {
	allowMultiple: true;
} & Omit<ListMultiChoiceVariableProps, "options">;

type SingleChoiceProps = { allowMultiple: false } & Omit<ListSingleChoiceVariableProps, "options">;

type Props = {
	matchers: Array<string>;
	label: string;
} & (MultiChoiceProps | SingleChoiceProps);

export const MetricLabelValues = ({ label, matchers, ...props }: Props) => {
	const { timeRange } = useDashboardContext();
	const [dropdownVisible, setDropdownVisible] = React.useState(false);

	const { data, error } = useQuery({
		...queryMetricsLabelValues({
			timeRange: useScoped(timeRange),
			label,
			matches: matchers,
		}),
		keepPreviousData: true,
		enabled: dropdownVisible,
	});

	if (props.allowMultiple) {
		return (
			<ListMultiChoiceVariable
				{...props}
				onDropdownVisibleChange={setDropdownVisible}
				options={error || data == null ? [] : data.map((value) => ({ value }))}
			/>
		);
	}

	return (
		<ListSingleChoiceVariable
			{...props}
			onDropdownVisibleChange={setDropdownVisible}
			options={error || data == null ? [] : data.map((value) => ({ value }))}
		/>
	);
};
